export default "__VITE_ASSET__BRiSFI2b__"